<template>
  <div class="recruit">
    <div class="header"></div>
    <form @submit="onSubmit">
      <Input placeholder="您的姓名" v-model="name"/>
      <Input placeholder="您的手机号" v-model="cellphone"/>
      <Region placeholder="请选择所在城市" v-model="region" :labels="['省份', '城市']" :closeable="false"/>
      <button class="submit" :class="{disabled}" type="submit">提交信息，加入收钱吧</button>
    </form>
    <div class="content">
      <div class="item">
        <div class="bg bg1"></div>
        <div>
          <p>在收钱吧，有近1000名BD，</p>
          <p>每天奔走在拓业的道路上，</p>
          <p>他们把专业、用心的服务带给大大小小的商家。</p>
        </div>
      </div>
      <div class="item">
        <div class="bg bg2"></div>
        <div>
          <p>他们帮助一家家商户了解和使用"收钱吧"，</p>
          <p>助力商家迎上移动支付潮流，做好每一笔生意。</p>
          <p>迄今为止，已有超过150万商家选择了收钱吧</p>
          <p>超过6000万粉丝，喜欢收钱吧！</p>
        </div>
      </div>
      <div class="item">
        <div class="bg bg3"></div>
        <div>
          <p>在收钱吧，不讲出身，无论资历，不怕你是小白，</p>
          <p>"新兵训练营"团队长训练营"师徒一带一"</p>
          <p>只要你愿意学公司就用心培养，</p>
          <p>收钱吧的团队主管，城市经理100%来自一线销售</p>
        </div>
      </div>
      <div class="item">
        <div class="bg bg4"></div>
        <div>
          <p>在收钱吧，只要肯努力，</p>
          <p>BD入职3个月平均收入突破万元，</p>
          <p>平均入职6个月就能获得一次晋升！</p>
          <p>努力和坚持就能得到超乎预期的薪酬，</p>
          <p>极速上升的通道，和无限成长的空间。</p>
        </div>
      </div>
    </div>
    <div class="city">
      <div class="title">
        <p>让我们一起来走，</p>
        <p>坚定的信念，规划的路线</p>
        <p>真正的挑战要用行动来实现</p>
      </div>
      <div class="detail">
        <div class="yellow"></div>
        <div class="content">
          <div class="little-title">
            <p>收钱吧全国五大区</p>
            <p>近40个城市火热招聘中</p>
          </div>
          <div class="distinct">
            <div class="distinct-title">华东区</div>
            <div>上海&nbsp;|&nbsp;杭州&nbsp;|&nbsp;南京&nbsp;|&nbsp;宁波&nbsp;|&nbsp;合肥&nbsp;|&nbsp;无锡&nbsp;|&nbsp;温州&nbsp;|&nbsp;苏州</div>
          </div>
          <div class="distinct">
            <div class="distinct-title">华西区</div>
            <div>重庆&nbsp;|&nbsp;成都&nbsp;|&nbsp;西安&nbsp;|&nbsp;昆明&nbsp;|&nbsp;贵阳&nbsp;</div>
          </div>
          <div class="distinct">
            <div class="distinct-title">华南区</div>
            <div>广州&nbsp;|&nbsp;深圳&nbsp;|&nbsp;福建&nbsp;|&nbsp;厦门&nbsp;|&nbsp;海口&nbsp;|&nbsp;南宁&nbsp;</div>
          </div>
          <div class="distinct">
            <div class="distinct-title">华中区</div>
            <div>武汉&nbsp;|&nbsp;长沙&nbsp;|&nbsp;郑州&nbsp;|&nbsp;南昌</div>
          </div>
          <div class="distinct last">
            <div class="distinct-title">华北区</div>
            <div>北京&nbsp;|&nbsp;天津&nbsp;|&nbsp;青岛&nbsp;|&nbsp;济南&nbsp;|&nbsp;大连&nbsp;|&nbsp;太原&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact">
      <p>心动不如行动</p>
      <p>快快投递简历至</p>
      <p class="email">sales@shouqianba.com</p>
      <p>或填写个人信息</p>
      <p>当地收钱吧的伙伴会第一时间联系你！</p>
      <img src="../../assets/images/qrcode.jpg" alt="二维码">
      <p class="tips">长按关注"喔噻招聘"官方微信号</p>
    </div>
    <div class="logo-wrap">
      <div class="logo"></div>
    </div>
    <Pull/>
  </div>
</template>

<script>
  import { Form, Input, Region, Pull } from '../../components'
  import { checkPhone } from '../../utils'

  export default {
    components: { Form, Input, Region, Pull },
    data() {
      return {
        name: '',
        cellphone: '',
        region: '',
        disabled: false
      }
    },
    methods: {
      async onSubmit(e) {
        e.preventDefault()
        if (this.checked()) {
          const { name, cellphone, region } = this
          const [ { name: province }, { name: city } ] = region
          this.disabled = true
          const { msg, data } = await this.$axios.post('/form/candidate', {
            name,
            cellphone,
            province,
            city
          })
          if (data) {
            this.$toast('提交成功')
          } else {
            this.$toast(msg)
            this.disabled = false
          }
        }
      },
      checked() {
        const { name, cellphone, region } = this
        if (!name) return this.$toast('请填写申请人姓名')
        if (!cellphone) return this.$toast('请填写申请人手机号码')
        if (!checkPhone(cellphone)) return this.$toast('手机号码格式不正确')
        if (region.length < 2) return this.$toast('请选择所在城市')
        return true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .recruit {
    // padding-bottom:5rem;
  }

  .header {
    width: 100%;
    padding-top: 100%;
    background: url("../../assets/images/header.jpg") top center no-repeat;
    background-size: 100% auto;
  }

  .submit {
    $size: 4.5rem;
    position: relative;
    display: block;
    margin: 0 auto;
    width: 29.58rem;
    height: $size;
    line-height: $size;
    color: #fff;
    font-size: 1.5rem;
    font-weight: 600;
    text-align: center;
    padding: 0;
    border: none;
    outline: none;
    border-radius: $size;
    box-shadow: 0 1rem 1.5rem rgba(240, 150, 60, .5);
    background: linear-gradient(to top, #FFB905, #FA8C16);
    &.disabled {
      color: #fff !important;
      background: #e2e2e2 !important;
      box-shadow: 0 1rem 1.5rem rgba(0, 0, 0, .05);
    }
  }

  .content {
    width: 100%;
    height: auto;
    background-image: url("../../assets/images/bg.png");
    background-repeat: repeat-y;
    background-size: contain;
  }

  .item {
    margin: 0 1rem;
    padding: 2rem 0;
    border-bottom: solid 1px #ccc;
    .bg {
      width: 20.75rem;
      margin: 0 auto;
    }
    .bg1 {
      height: 17.75rem;
      background-image: url("../../assets/images/1.jpg");
      background-size: contain;
      background-repeat: no-repeat;
    }
    .bg2 {
      height: 14.42rem;
      background-image: url("../../assets/images/2.jpg");
      background-size: contain;
      background-repeat: no-repeat;
    }
    .bg3 {
      height: 20.9rem;
      background-image: url("../../assets/images/3.jpg");
      background-size: contain;
      background-repeat: no-repeat;
    }
    .bg4 {
      height: 15.47rem;
      background-image: url("../../assets/images/4.jpg");
      background-size: contain;
      background-repeat: no-repeat;
    }
    p {
      text-align: center;
      font-size: 1.2rem;
      margin: 0;
    }
  }

  .city {
    margin: 1rem;
    .title {
      font-size: 1.6rem;
      font-weight: bold;
      padding: 1.5rem 0;
      p {
        text-align: center;
        color: #cd962e;
        margin: 0;
      }
    }
    .detail {
      border: solid 1px #ffdb3f;
      border-radius: 0.2rem;
      background: #fbf9f1;
      box-shadow: 1px 1px 4px #d8d8d8;
      .yellow {
        height: 1rem;
        background: #ffdb3f;
      }
      .content {
        padding: 2rem;
      }
      .little-title {
        color: #222222;
        font-size: 1.5rem;
        p {
          margin: 0;
        }
      }
      .distinct {
        padding: 1rem 0;
        color: #222;
        font-size: 1.1rem;
        border-bottom: dashed 1px #cd962e;
        .distinct-title {
          color: #cd962e;
          font-size: 1.5rem;
        }
      }
      .last {
        border-bottom: 0;
      }
    }
  }

  .contact {
    margin: 1rem;
    p {
      text-align: center;
      margin: 0;
      font-size: 1.2rem;
    }
    .email {
      color: #cd962e;
    }
    img {
      display: block;
      margin: 2rem auto;
      width: 10rem;
      height: 10rem;
      border: solid 1px #cd962e;
      border-radius: 0.5rem;
      padding: 1rem;
    }
    .tips {
      font-size: 1rem;
      color: #747474;
    }
  }

  .logo-wrap {
    width: 100%;
    padding: 2rem 0;
    background: #ffdb3f;
    margin: 2rem 0 5rem 0;
    .logo {
      width: 14.02rem;
      height: 4.61rem;
      background-image: url("../../assets/images/logo.png");
      background-size: contain;
      margin: 0 auto;
    }
  }
</style>


